import React, { useState } from 'react'
import List from './List'
import InsuranceDetails from './InsuranceDetails'
export default function Main({ }) {
  const [tab, setTab] = useState("list")
  const [detailData,setDetailData] =useState({})

  const handleType = (type,data) => {
    setTab(type)
    setDetailData(data)
  }
  
  return (
    <>
    {
      tab === "list" ?
      <List 
      handleType={handleType}
      />
    :''}
    {
      tab === "details" ?
      <InsuranceDetails
      handleType={handleType}
      detailData={detailData}
      />
    :''}
    </>
  )
}
